import { Action } from "../actionTypes";

const initState = {
    // Current user state
    currentUserId: null,
    currentUserData: null,
    originalUserId: null, // For B2B account switching
    
    // Active account state (can be user's own account or B2B account they have access to)
    activeAccountId: null,
    activeAccountType: 'personal', // 'personal' | 'b2b'
    
    // Admin switching state
    isAdminMode: false,
    originalAdminId: null,
    adminPermissionMode: false, // When in admin mode, whether using admin permissions (true) or user permissions (false)
    
    // User permissions for current active account
    userPermissions: {
        billing: false,
        user_management: false,
        analytics: false,
        experience_creation: false,
        admin_experience_creation: false,
        create_products_markers: false
    },
    userRole: null, // 'primary' | 'sub-user' | null
    
    // Available accounts for switching
    availableAccounts: [],
    
    // Loading states
    loading: false,
    error: ""
};

const store = (state = initState, action: any) => {
    switch (action.type) {
        case Action.INITIALIZE_ACCOUNT_STATE:
            return {
                ...state,
                currentUserId: action.payload.currentUserId,
                activeAccountId: action.payload.activeAccountId,
                activeAccountType: action.payload.activeAccountType,
                isAdminMode: action.payload.isAdminMode,
                originalAdminId: action.payload.originalAdminId,
                adminPermissionMode: action.payload.adminPermissionMode,
                originalUserId: action.payload.originalUserId,
                userPermissions: action.payload.userPermissions,
                userRole: action.payload.userRole
            }
        case Action.SWITCH_ACCOUNT_INIT:
            return {
                ...state,
                loading: true,
                error: ""
            }
        case Action.SWITCH_ACCOUNT_SUCCESS:
            return {
                ...state,
                loading: false,
                activeAccountId: action.payload.activeAccountId,
                activeAccountType: action.payload.activeAccountType,
                userPermissions: action.payload.userPermissions || state.userPermissions,
                userRole: action.payload.userRole || null,
                isAdminMode: action.payload.isAdminMode || false,
                originalAdminId: action.payload.originalAdminId || null,
                originalUserId: action.payload.originalUserId,
                adminPermissionMode: action.payload.adminPermissionMode || false,
                error: ""
            }
        case Action.SWITCH_ACCOUNT_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
            
        case Action.GET_ACCOUNT_PERMISSIONS_INIT:
            return {
                ...state,
                loading: true
            }
        case Action.GET_ACCOUNT_PERMISSIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                availableAccounts: action.payload.availableAccounts || [],
                userPermissions: action.payload.currentPermissions || state.userPermissions,
                userRole: action.payload.currentRole || null,
                error: ""
            }
        case Action.GET_ACCOUNT_PERMISSIONS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
            
        case Action.SWITCH_BACK_TO_ADMIN_INIT:
            return {
                ...state,
                loading: true
            }
        case Action.SWITCH_BACK_TO_ADMIN_SUCCESS:
            return {
                ...state,
                loading: false,
                currentUserId: action.payload.currentUserId,
                activeAccountId: action.payload.activeAccountId,
                activeAccountType: 'personal',
                isAdminMode: false,
                originalAdminId: null,
                adminPermissionMode: false,
                userPermissions: {
                    billing: true,
                    user_management: true,
                    analytics: true,
                    experience_creation: true,
                    admin_experience_creation: true,
                    create_products_markers: true
                },
                userRole: null,
                error: ""
            }
        case Action.SWITCH_BACK_TO_ADMIN_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
            
        // Removed ACCEPT_B2B_INVITATION cases since we now use seamless invitation processing
        // case Action.ACCEPT_B2B_INVITATION_INIT:
        //     return {
        //         ...state,
        //         isAcceptingInvitation: true,
        //         acceptInvitationError: null,
        //     }
        // case Action.ACCEPT_B2B_INVITATION_SUCCESS:
        //     return {
        //         ...state,
        //         isAcceptingInvitation: false,
        //         acceptInvitationError: null,
        //         // Add the new business account to user's permissions
        //         userPermissions: {
        //             ...state.userPermissions,
        //             [action.payload.businessId]: {
        //                 permissions: action.payload.permissions,
        //                 role: action.payload.role,
        //                 business_name: action.payload.businessName
        //             }
        //         }
        //     }
        // case Action.ACCEPT_B2B_INVITATION_FAIL:
        //     return {
        //         ...state,
        //         isAcceptingInvitation: false,
        //         acceptInvitationError: action.payload,
        //     }
            
        // Set initial user data and account state
        case Action.AUTH_LOGIN_SUCCESS:
            return {
                ...state,
                currentUserId: action.payload.uid,
                currentUserData: action.payload,
                activeAccountId: action.payload.uid,
                activeAccountType: 'personal',
                isAdminMode: false,
                originalAdminId: null,
                userPermissions: {
                    billing: true,
                    user_management: true,
                    analytics: true,
                    experience_creation: true,
                    admin_experience_creation: action.payload.protected?.isAdmin || false,
                    create_products_markers: true
                },
                userRole: null
            }
            
        case Action.TOGGLE_ADMIN_PERMISSION_MODE:
            return {
                ...state,
                adminPermissionMode: action.payload.adminPermissionMode,
                userPermissions: action.payload.userPermissions || state.userPermissions,
                userRole: action.payload.userRole !== undefined ? action.payload.userRole : state.userRole
            }
            
        default:
            return state;
    }
};

export default store; 